import React from 'react';
import reconnectImage from '../../images/reconnect-email.png';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Button } from 'reactstrap';

interface PropTypes {
  url: string;
  largeImage?: boolean;
  onClose: () => void;
  informationText: string;
  actionText: React.ReactNode;
}

export function DisconnectedIntegrationModalBody(props: PropTypes) {
  return (
    <div className='d-flex flex-column align-items-center'>
      <img
        src={reconnectImage}
        alt='Reconnect Email Integration'
        className={classNames(
          props.largeImage ? styles['main-image-large'] : styles['main-image'],
          'mb-4',
        )}
      />
      <div className='row justify-content-center text-center'>
        <div className='fw-bold fs-4 mb-2h'>{props.informationText}</div>
        <div className='fw-semibold fs-5'>{props.actionText}</div>
      </div>
      <div className='d-flex justify-content-end mt-4 gap-3 w-100'>
        <Button color='danger' onClick={() => props.onClose()}>
          Close
        </Button>
        <Button
          color='primary'
          onClick={() => (window.location.href = props.url)}
        >
          Reconnect
        </Button>
      </div>
    </div>
  );
}
